export default __webpack_public_path__ + "static/Oil_Pump-59f0f43324b8c50c73ef05347c24ac6a.png";